import axios from 'axios';
import { useState, useEffect } from 'react';

interface Province {
  code: string;
  name: string;
  regionName: string;
  islandGroupCode: string;
  psgc10DigitCode: string;
}

interface City {
  code: string;
  name: string;
  oldName: string;
  isCapital: boolean;
  isCity: boolean;
  isMunicipality: boolean;
  provinceCode: string;
  districtCode: string;
  regionCode: string;
  islandGroupCode: string;
  psgc10DigitCode?: string;
}

interface Barangay {
  code: string;
  name: string;
  oldName: string;
  subMunicipalityCode: string;
  cityCode: string;
  municipalityCode: string;
  districtCode: string;
  provinceCode: string;
  regionCode: string;
  islandGroupCode: string;
}

const PSGC_API = 'https://psgc.gitlab.io/api';
const NCR_CODE = '130000000';

export function useLocationData() {
  const [provinces, setProvinces] = useState<Province[]>([]);
  const [cities, setCities] = useState<City[]>([]);
  const [barangays, setBarangays] = useState<Barangay[]>([]);

  useEffect(() => {
    const fetchProvinces = async () => {
      try {
        const res = await axios.get(`${PSGC_API}/provinces.json`);
        const additionalProvince = {
          code: '130000000',
          name: 'NCR',
          regionName: 'National Capital Region',
          islandGroupCode: 'luzon'
        };
        setProvinces([additionalProvince, ...res.data]);
      } catch (error) {
        console.error('Error fetching provinces:', error);
      }
    };

    fetchProvinces();
  }, []);

  const fetchCities = async (provinceCode: string) => {
    try {
      let endpoint;
      if (provinceCode === NCR_CODE) {
        endpoint = `${PSGC_API}/regions/${provinceCode}/cities-municipalities.json`;
      } else {
        endpoint = `${PSGC_API}/provinces/${provinceCode}/cities-municipalities.json`;
      }
      const res = await axios.get(endpoint);
      setCities(res.data);
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  const fetchBarangays = async (
    districtCode: string | boolean,
    municipalityCode: string | boolean
  ) => {
    try {
      if (districtCode !== false) {
        const res = await axios.get(
          `${PSGC_API}/districts/${districtCode}/barangays.json`
        );
        setBarangays(res.data);
      } else if (municipalityCode !== false) {
        const res = await axios.get(
          `${PSGC_API}/cities-municipalities/${municipalityCode}/barangays.json`
        );
        setBarangays(res.data);
      }
    } catch (error) {
      console.error('Error fetching barangays:', error);
    }
  };

  return { provinces, cities, barangays, fetchCities, fetchBarangays };
}
